import { useMemo, useState } from "react";
import { ComponentProps } from "@arelia-types/widget";
import { useQuery } from "react-query";
import { http } from "src/api/http";
import RevenuePresenter from "./RevenuePresenter";
import { DashboardPeriod, DashboardPeriodDisplay, PeriodDisplay } from "@arelia-utils/constants/constants";
import WidgetMenuSelector from "@arelia-components/ui-atoms/WidgetMenuSelector";
import getMenuItems from "@arelia-utils/helpers/getMenuItems";

export default function RevenueContainer({ config }: ComponentProps) {
  const [selectedPeriod, setSelectedPeriod] = useState(DashboardPeriod.Year);
  const [selectedPeriodDisplay, setSelectedPerionDisplay] = useState<PeriodDisplay>(DashboardPeriodDisplay.Year);

  const { data, isLoading } = useQuery<any>({
    queryKey: ['useHqRevenue', selectedPeriod],
    queryFn: () => http(`/api/hq/revenue?period=${selectedPeriod}`)
  });

  const widgetData = useMemo(() => ({
    revenueGross: data?.revenueGross,
    revenueNet: data?.revenueNet,
    fees: data?.fees,
  }), [data]);

  const menuItems = getMenuItems(DashboardPeriodDisplay);

  const setPeriod = (period: DashboardPeriod) => {
    setSelectedPeriod(period);
    setSelectedPerionDisplay(DashboardPeriodDisplay[period]);
  }

  const renderPeriodSelector = () => (
    <WidgetMenuSelector<DashboardPeriod>
      onClick={setPeriod}
      selectedValue={selectedPeriod}
      labelText={selectedPeriodDisplay.menuLabelDisplay}
      menuItems={menuItems}
    />
  );

  return (
    <RevenuePresenter
      data={widgetData}
      loading={isLoading}
      widgetConfig={config}
      headerComponent={renderPeriodSelector()}
    />
  );
}